import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import CockpitPage from './pages/CockpitPage';
import SantePage from './pages/SantePage';
import TokensPage from './pages/TokensPage';
import PositionsPage from './pages/PositionsPage';
import PerformancePage from './pages/PerformancePage';
import LoginPage from './pages/LoginPage';
import UsersPage from './pages/UsersPage';
import CreatorsPage from './pages/CreatorsPage';
import CopiedWalletsPage from './pages/CopiedWalletsPage';
import BacktestsPage from './pages/BacktestsPage';
import DiscoveryPage from './pages/DiscoveryPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<ProtectedRoute />}>
                {/* Toutes les pages = full-screen self-contained (side-rail .sb propre, hors Layout) */}
                <Route path="/" element={<Navigate to="/cockpit" replace />} />
                <Route path="/cockpit" element={<CockpitPage />} />
                <Route path="/positions" element={<PositionsPage />} />
                <Route path="/performance" element={<PerformancePage />} />
                <Route path="/tokens" element={<TokensPage />} />
                <Route path="/sante" element={<SantePage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/creators" element={<CreatorsPage />} />
                <Route path="/wallets" element={<CopiedWalletsPage />} />
                <Route path="/backtests" element={<BacktestsPage />} />
                <Route path="/discovery" element={<DiscoveryPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
